import { render, staticRenderFns } from "./Loding.vue?vue&type=template&id=31abe70b&scoped=true&"
import script from "./Loding.vue?vue&type=script&lang=js&"
export * from "./Loding.vue?vue&type=script&lang=js&"
import style0 from "./Loding.vue?vue&type=style&index=0&id=31abe70b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31abe70b",
  null
  
)

export default component.exports